import { useTranslation } from 'react-i18next'

import { TaskStatusToggle, TaskStatusType } from '../../Task'
import { BirdviewRowAddress } from '../BirdviewRowAddress'
import { BirdviewRowDeadline } from '../BirdviewRowDeadline'
import { DashboardListRow } from '../DashboardListRow'

import {
  checkCanOpenBirdviewActivity,
  getBirdviewActivityStatusKey,
  getBirdviewActivityStatusTooltipKey,
} from './BirdviewActivityRow.utils'

import TaskIcon from '../../../icons/task.svg'

function BirdviewActivityRow({
  isDone,
  isPending,
  item,
  onOpen,
  onStatusToggle,
}) {
  const { t } = useTranslation()

  function handleOpen() {
    if (checkCanOpenBirdviewActivity(item)) {
      onOpen(item)
    }
  }

  function handleStatusToggle() {
    onStatusToggle(item)
  }

  return (
    <DashboardListRow
      Before={TaskStatusToggle}
      Icon={TaskIcon}
      Meta={BirdviewRowDeadline}
      Subtitle={BirdviewRowAddress}
      beforeProps={{
        checked: isDone,
        disabled: !item.canToggleDone,
        isLoading: isPending,
        text: t(getBirdviewActivityStatusKey(isDone)),
        tooltip: t(getBirdviewActivityStatusTooltipKey(isDone)),
        type: TaskStatusType.Done,
        onChange: handleStatusToggle,
      }}
      metaProps={{ deadline: item.deadline }}
      subtitleProps={{ address: item.address, assignee: item.assignee }}
      title={item.title}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewActivityRow
